import * as React from 'react'
import { SVGProps } from 'react'

const Active = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={15}
        height={16}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect
            x={0.444}
            y={1.333}
            width={13.333}
            height={13.333}
            rx={6.667}
            fill="#006ABF"
            stroke="#fff"
            strokeWidth={0.889}
        />
    </svg>
)

export default Active
